import { render, staticRenderFns } from "./TicketComment.vue?vue&type=template&id=560ac43c&scoped=true"
import script from "./TicketComment.vue?vue&type=script&lang=js"
export * from "./TicketComment.vue?vue&type=script&lang=js"
import style0 from "./TicketComment.vue?vue&type=style&index=0&id=560ac43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ac43c",
  null
  
)

export default component.exports